import React, { ReactNode } from "react";
import { Dialog } from "primereact/dialog";
interface CustomDialogProps {
  visible: boolean;
  header?: string;
  closeModalDialog?: () => void;
  children: ReactNode;
  customStyle?: {};
}
const CustomDialog = ({
  visible,
  closeModalDialog,
  header,
  children,
  customStyle,
}: CustomDialogProps) => {
  return (
    <Dialog
      header={header}
      visible={visible}
      style={customStyle ? customStyle : { width: "50vw" }}
      onHide={() => closeModalDialog()}
      dismissableMask
      maximizable
    >
      {children}
    </Dialog>
  );
};

export default CustomDialog;
